import { createAction } from '@reduxjs/toolkit';
import { IField } from '../interfaces/fields';
import CountryVO from '../interfaces/CountryVO';

export const setFieldMeta = createAction<IField[]>('SET_FIELD_META');
export const setCountryMeta = createAction<CountryVO[]>('SET_COUNTRY_META');
